import React from 'react';
import { useTranslation } from 'react-i18next';

import { General, MediaDevices, Users } from 'icons/untitledui';
import * as DropdownStyled from 'theme/components/Dropdown.style';
import * as SelectionStyled from 'theme/components/SelectionDropdown.style';
import * as Styled from '../../styles/FilterGroupingControl.style';
import { Source } from './_types';

interface SourceFilterMenuProps {
  selected: Source | null;
  onSelect: (value: Source | null) => void;
  topOffset?: number;
}

const OPTIONS: Source[] = ['user', 'camera'];

export default function SourceFilterMenu({
  selected,
  onSelect,
  topOffset,
}: SourceFilterMenuProps): JSX.Element {
  const { t } = useTranslation('pageEvents');

  return (
    <Styled.PopoverCard $zIndex={1400} $topOffset={topOffset} $leftOffset={-40}>
      <Styled.List>
        <DropdownStyled.SectionHeader>
          {t('filterGrouping.source.title')}
        </DropdownStyled.SectionHeader>
        {OPTIONS.map((source) => {
          const isSelected = selected === source;
          const Icon =
            source === 'camera' ? MediaDevices.VideoRecorder : Users.User01;
          return (
            <SelectionStyled.Option
              key={source}
              type="button"
              $selected={isSelected}
              onClick={() => onSelect(isSelected ? null : source)}
              role="menuitemradio"
              aria-checked={isSelected}
            >
              <Styled.LeadingRow>
                <DropdownStyled.ItemLeadingIcon>
                  <Icon size={20} />
                </DropdownStyled.ItemLeadingIcon>
                <span>{t(`filterGrouping.source.options.${source}`)}</span>
              </Styled.LeadingRow>
              <SelectionStyled.OptionCheck $selected={isSelected}>
                {isSelected && <General.Check size={16} />}
              </SelectionStyled.OptionCheck>
            </SelectionStyled.Option>
          );
        })}
      </Styled.List>
    </Styled.PopoverCard>
  );
}
